var map = {
	"./basketball.webp": 1691,
	"./bti-img.webp": 1692,
	"./bti-title-cn.webp": 1693,
	"./bti-title-en.webp": 1694,
	"./cup.webp": 1695,
	"./football.webp": 1696,
	"./im-img.webp": 1697,
	"./im-title-cn.webp": 1698,
	"./im-title-en.webp": 1699,
	"./sb-img.webp": 1700,
	"./sb-title-cn.webp": 1701,
	"./sb-title-en.webp": 1702,
	"./sbo-img.webp": 1703,
	"./sbo-title-cn.webp": 1704,
	"./sbo-title-en.webp": 1705,
	"./sport-bg.webp": 1706,
	"./sport-ctg.webp": 1707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 791;